<template>
  <div class="grid-ro-folder-view">
    <h2 class="ro-folder-view__title">{{ title }}</h2>

    <div class="ro-folder-view__container">
      <div
        class="ro-folder-view__breadcrumbs"
        v-if="openFolders && openFolders.length"
      >
        <span
          v-for="(folder, index) in openFolders"
          :key="index"
          :class="[
            'ro-folder-view__breadcrumbs__title',
            {
              'ro-folder-view__breadcrumbs__title--current':
                folder.name === currentItems.name,
            },
          ]"
          :tabindex="0"
          @keyup.enter="goToFolder(index)"
          @click="goToFolder(index)"
          :aria-label="('Gå til', folder.name)"
          role="button"
          >{{ folder.name }}

          <span
            class="ro-folder-view__breadcrumb__seperator"
            v-if="index < openFolders.length - 1"
          >
            >
          </span>
        </span>
      </div>
      <ul v-if="currentItems && currentItems.children.length">
        <li
          v-for="(item, index) in currentItems.children"
          :key="(index, item.name)"
          @keyup.enter="selectFolder(item)"
          @click="selectFolder(item)"
          :tabindex="0"
          :aria-label="item.name"
          ref="folderListItem"
          :title="item.size ? formattedFileSize(item.size) : null"
          :role="item.children ? 'button' : 'link'"
          class="ro-folder-view__item"
        >
          <sky-svg
            :name="item.url ? 'file' : 'folder'"
            class="ro-folder-view__icon"
          />

          {{ item.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "RoFolderView",
  props: {
    title: String,
    data: String,
  },

  data() {
    return {
      openFolders: [],
      currentItems: { name: "", children: [] },
    };
  },

  computed: {
    formattedFileSize() {
      return (size) => {
        const units = ["B", "KB", "MB", "GB", "TB"];
        let index = 0;

        while (size >= 1024 && index < units.length - 1) {
          size /= 1024;
          index++;
        }

        return size.toFixed(2) + " " + units[index];
      };
    },
  },
  created() {
    const parsedData = JSON.parse(this.data);
    if (parsedData) {
      this.currentItems = {
        name: parsedData.name,
        children: parsedData.children || [],
      };
      this.openFolders.push({ name: parsedData.name, data: parsedData });
    }
  },

  methods: {
    isOpen(item) {
      return this.openFolders.some((folder) => folder.name === item.name);
    },

    selectFolder(item) {
      if (item.children) {
        this.currentItems = { name: item.name, children: item.children };
        this.$nextTick(() => {
          const firstItem = this.$refs.folderListItem[0];
          if (firstItem) {
            firstItem.focus();
            console.log(firstItem);
          }
        });
        this.openFolders.push({ name: item.name, data: item });
      } else if (item.url) {
        // If it's a file with a URL, open the link
        window.open(item.url, "_blank");
      }
    },

    goToFolder(index) {
      // Navigate back to a specific folder in breadcrumbs
      this.openFolders = this.openFolders.slice(0, index + 1);
      // Update currentItems with the children of the selected folder's parent
      const folderData = this.openFolders[index].data;
      this.currentItems = {
        name: folderData.name,
        children: folderData.children || [],
      };
    },
  },
};
</script>

<style src="./RoFolderView.scss"></style>



// WEBPACK FOOTER //
// RoFolderView.vue?63a196f4